<script setup lang="ts">
import type { ComboboxContentEmits, ComboboxContentProps } from 'reka-ui';
import { cn } from '../ui-utils.ts';
import { ComboboxContent, useForwardPropsEmits } from 'reka-ui';
import { computed, type HTMLAttributes } from 'vue';

const props = defineProps<ComboboxContentProps & { class?: HTMLAttributes['class'] }>();
const emits = defineEmits<ComboboxContentEmits>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <ComboboxContent v-bind="forwarded" :class="cn('max-h-[300px] overflow-x-hidden overflow-y-auto', props.class)">
    <div role="presentation">
      <slot />
    </div>
  </ComboboxContent>
</template>
